/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Portal_Perk_DietInputs */

const en_portal_perk_diet = /** @type {(inputs: Portal_Perk_DietInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Diet and calories from a photo`)
};

const pl_portal_perk_diet = /** @type {(inputs: Portal_Perk_DietInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dieta i kalorie ze zdjęcia`)
};

/**
* | output |
* | --- |
* | "Diet and calories from a photo" |
*
* @param {Portal_Perk_DietInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const portal_perk_diet = /** @type {((inputs?: Portal_Perk_DietInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Portal_Perk_DietInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_portal_perk_diet(inputs)
	return en_portal_perk_diet(inputs)
});